import React from "react";

export const RightIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="65"
        viewBox="0 0 64 65"
        fill="none">
        <path
          d="M32 16.5L29.14 19.286L40.3 30.5H16V34.5H40.3L29.14 45.646L32 48.5L48 32.5L32 16.5Z"
          fill="white"
        />
        <path
          d="M32 60.5C26.4621 60.5 21.0486 58.8578 16.444 55.7812C11.8395 52.7045 8.25064 48.3315 6.13139 43.2151C4.01213 38.0988 3.45764 32.469 4.53802 27.0375C5.61841 21.606 8.28515 16.6169 12.201 12.701C16.1169 8.78515 21.106 6.11841 26.5375 5.03802C31.969 3.95764 37.5988 4.51213 42.7151 6.63139C47.8315 8.75064 52.2045 12.3395 55.2812 16.944C58.3578 21.5486 60 26.9621 60 32.5C59.9915 39.9235 57.0388 47.0405 51.7896 52.2896C46.5405 57.5388 39.4235 60.4915 32 60.5ZM32 8.50001C27.2533 8.50001 22.6131 9.90759 18.6663 12.5447C14.7195 15.1819 11.6434 18.9302 9.8269 23.3156C8.0104 27.701 7.53512 32.5266 8.46117 37.1822C9.38721 41.8377 11.673 46.1141 15.0294 49.4706C18.3859 52.827 22.6623 55.1128 27.3178 56.0389C31.9734 56.9649 36.799 56.4896 41.1844 54.6731C45.5698 52.8566 49.3181 49.7805 51.9553 45.8337C54.5924 41.8869 56 37.2468 56 32.5C55.9926 26.1371 53.4617 20.0369 48.9624 15.5376C44.4631 11.0384 38.3629 8.50742 32 8.50001Z"
          fill="white"
        />
      </svg>
    </div>
  );
};
